import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: ReactNode;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ leftIcon, error, className, ...rest }, ref) => (
    <div className="w-full">
      <div className="relative">
        {leftIcon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink-500" aria-hidden>
            {leftIcon}
          </span>
        )}
        <input
          ref={ref}
          className={cn(
            'w-full h-10 rounded-md border border-ink-200 bg-ink-50 text-ink-900 placeholder:text-ink-500',
            'px-3 text-[13.5px]',
            'transition-colors duration-150',
            'focus:border-brand-400 focus:bg-surface focus:ring-2 focus:ring-brand-100 focus:outline-none',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            leftIcon && 'pl-9',
            error && 'border-red-300 focus:border-red-500 focus:ring-red-100',
            className,
          )}
          {...rest}
        />
      </div>
      {error && <p className="mt-1.5 text-[11.5px] font-medium text-red-600">{error}</p>}
    </div>
  ),
);

Input.displayName = 'Input';
